import React from "react";
import { ticketLabelAvailable } from "../../../constant/fakeDataTicket";
import { useLanguage } from "../../../hooks/useLanguage";

function TitleTicket({ ticket, index }) {
  const { nameWithLanguage } = useLanguage();

  return (
    <div className="col-span-6">
      <div className="flex flex-row gap-x-4">
        <div>
          <div
            className="w-6 h-6 rounded "
            style={{
              backgroundColor: ticketLabelAvailable[0].color,
            }}
          />
        </div>
        <p
          className={
            "  font-medium md:text-body-1 text-body-2 text-neutral-800  md:font-medium lg:text-body-1 lg:font-medium"
          }
        >
          {ticket ? ticket[nameWithLanguage] : ""}
          {/* vip 1 */}
        </p>
      </div>
    </div>
  );
}
export default TitleTicket;
